import React from 'react';
import PropTypes from 'prop-types';
import {Link, useLocation} from 'react-router-dom';

import Icon from '@mui/material/Icon';
import {List, ListItemButton, ListItemText, Toolbar, ListItemIcon, useMediaQuery, useTheme} from '@mui/material';

import {MENU_ITEMS} from 'routes';
import {StyledListItem} from 'components/styled';
import ConditionalWrapper from './conditionalWrapper';

//REDUX
import {connect} from 'react-redux';
import {setIsMenuDrawerOpen} from 'redux/slices/appHeaderSlice';

const SideBar = ({setIsDrawerOpen}) => {
  let location = useLocation();
  const mobile = useMediaQuery(useTheme().breakpoints.down('md'));

  return (
    <ConditionalWrapper isMobile={mobile}>
      <Toolbar style={{display: mobile && 'none'}} />
      <List>
        {MENU_ITEMS?.map(({icon, title, path}) => (
          <StyledListItem isactive={`${path === location?.pathname}`} key={title} disablePadding>
            <ListItemButton onClick={() => setIsDrawerOpen(false)} component={Link} to={path}>
              <ListItemIcon>
                <Icon component={icon}></Icon>
              </ListItemIcon>
              <ListItemText primary={title} />
            </ListItemButton>
          </StyledListItem>
        ))}
      </List>
    </ConditionalWrapper>
  );
};

SideBar.propTypes = {
  setIsDrawerOpen: PropTypes.func
};

const mapDispatchToProps = (dispatch) => {
  return {
    setIsDrawerOpen: (isOpen) => dispatch(setIsMenuDrawerOpen(isOpen))
  };
};

export default connect(null, mapDispatchToProps)(SideBar);
